// src/layouts/SplitMainLayout.js

import React, { memo, useEffect, useState } from "react";
import SideMenu from "../componentes/SideMenu";
import Footer from "../componentes/Footer";
import useRedirecionamentoAoLogin from "../hooks/useRedirecionamentoAoLogin";
import { SwapOutlined } from "@ant-design/icons";

const SplitMainLayout = memo(({ children, leftContent, rightContent, tabItems = [] }) => {
    useRedirecionamentoAoLogin();

    const [isLoading, setIsLoading] = useState(true);
    const [showLeftContent, setShowLeftContent] = useState(true);
    const [activeTab, setActiveTab] = useState("1");
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const timer = setTimeout(() => setIsLoading(false), 100);
        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    if (isLoading) {
        return (
            <div className="flex h-screen items-center justify-center bg-gray-100">
                <div className="h-12 w-12 animate-spin rounded-full border-4 border-blue-500 border-t-transparent" />
            </div>
        );
    }

    const defaultTabItems = [{ key: "1", label: "Conteúdo Principal", children: rightContent }];
    const finalTabItems = tabItems.length > 0 ? tabItems : defaultTabItems;

    const ToggleButton = () => {
        if (!isMobile) return null;
        return (
            <button
                onClick={() => setShowLeftContent(!showLeftContent)}
                className="fixed bottom-5 right-5 z-[1000] flex h-10 w-10 items-center justify-center rounded-full bg-blue-600 text-white shadow-lg hover:bg-blue-700 transition"
            >
                <SwapOutlined />
            </button>
        );
    };

    return (
        <div className="min-h-screen relative">
            <div className="flex min-h-screen relative">
                <SideMenu />

                <div className={`flex flex-col flex-1 transition-all relative ${isMobile ? "ml-0" : "ml-20"}`}>
                    {/* HeaderMenu foi removido daqui */}
                    <div className="flex flex-1 flex-row relative m-2 gap-2">
                        <div className={`flex flex-col rounded-lg bg-white shadow-md transition-all overflow-auto p-4 ${isMobile ? (showLeftContent ? "flex" : "hidden") : "flex-[0_0_24%]"}`}>
                            {leftContent}
                        </div>

                        <div className={`flex flex-col rounded-lg bg-white shadow-md transition-all overflow-auto p-4 ${isMobile ? (showLeftContent ? "hidden" : "flex") : "flex-[0_0_70%]"}`}>
                            <div className="flex flex-col">
                                <div className="flex border-b border-gray-200">
                                    {finalTabItems.map((tab) => (
                                        <button key={tab.key} onClick={() => setActiveTab(tab.key)} className={`px-4 py-2 text-sm font-medium transition ${activeTab === tab.key ? "border-b-2 border-blue-600 text-blue-600" : "text-gray-500 hover:text-gray-700"}`}>
                                            {tab.label}
                                        </button>
                                    ))}
                                </div>
                                <div className="p-4 flex-1">
                                    {finalTabItems.find((tab) => tab.key === activeTab)?.children}
                                </div>
                            </div>
                        </div>
                    </div>
                    <ToggleButton />
                    <Footer />
                </div>
            </div>
        </div>
    );
});

export default SplitMainLayout;